import styled from "styled-components"


const SKILLS = [
    {
        name: 'HTML',
        img: 'https://mirayhazlo.com/wp-content/uploads/2018/09/Html5_dise%C3%B1o_web-1.png'
    },
    {
        name: 'CSS',
        img: 'https://diziglobalsolution.com/wp-content/uploads/2023/04/logo-css-3-1536.png'
    },
    {
        name:'JavaScript',
        img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1200px-Unofficial_JavaScript_logo_2.svg.png'
    },
    {
        name: 'React JS',
        img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/React.svg/1200px-React.svg.png'
    },
    {
        name:'React Native (Expo)',
        img: 'https://play-lh.googleusercontent.com/algsmuhitlyCU_Yy3IU7-7KYIhCBwx5UJG4Bln-hygBjjlUVCiGo1y8W5JNqYm9WW3s'
    },
    {
        name: 'Astro',
        img: 'https://miro.medium.com/v2/resize:fit:1400/1*nLbfO_PdTSpeCdZQuUr8RQ.png'
    },
    {
        name: 'Vue.js',
        img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Vue.js_Logo_2.svg/1200px-Vue.js_Logo_2.svg.png'
    },
    {
        name: 'Next JS',
        img: 'https://testrigor.com/wp-content/uploads/2023/04/nextjs-logo-square.png'
    },
    {
        name: 'Node JS',
        img: 'https://miro.medium.com/v2/resize:fit:1097/1*CDklPJN-MCaCkZCCYEfNHw.png'
    },
    {
        name: 'Express',
        img: 'https://libreriasjs.com/wp-content/uploads/2023/02/logo_express-1.png'
    },
    {
        name: 'Nest JS',
        img: 'https://miro.medium.com/v2/resize:fit:1358/1*s9kgU8F1eB7Tzs7sG0YhBg.jpeg'
    },
    {
        name: 'Python',
        img: 'https://i0.wp.com/junilearning.com/wp-content/uploads/2020/06/python-programming-language.webp?fit=800%2C800&ssl=1'
    },
    {
        name: 'MySQL',
        img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFPLXqRyw5PEl4ETnuzYuP5XhUI51sUdQzcg&usqp=CAU'
    },
    {
        name: 'API Rest',
        img: 'https://media.licdn.com/dms/image/D4D12AQEeNNHq05k7MA/article-cover_image-shrink_720_1280/0/1687786979245?e=2147483647&v=beta&t=AVc2G-hvHNjTMklQtEt6qlby2l79Bf5dBBkUB5DBRe0'
    },
    {
        name: 'AWS',
        img: 'https://assets-global.website-files.com/6371f3e94a645947f33e2581/6371f3e94a6459433b3e2cd3_61b35b5f0a3b2a7eaea65906_AWS.jpeg'
    },
    {
        name: 'Figma',
        img: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg'
    },
    {
        name: 'Git',
        img: 'https://banner2.cleanpng.com/20180530/gbf/kisspng-github-repository-git-project-commit-5b0f2dd1efb513.5784673515277214259819.jpg'
    },
    {
        name: 'PHP'
    }
]

const ItemSkill = ({data}) => {
    return (
        <ItemSkillContainer>
            <div>
                <ImgContainer>
                    {data.img && <img alt="" src={data.img}/>}
                </ImgContainer>
            </div>
        {data.name}
    </ItemSkillContainer>
    )
}
export default function Habilidades() {
    return (
        <Container>
            {
                SKILLS.map((value, index) => <ItemSkill key={`skil--${index}`} data={value}/>)
            }
        </Container>
    )
}

const Container = styled.div`
display:grid;
grid-template-columns: repeat(2, 1fr);
padding:20px;
`
const ItemSkillContainer = styled.div`
display:flex;
gap:5px;
margin:5px 0;
user-select:none;
padding:8px;
border-radius:6px;
cursor:pointer;

border:1px solid transparent;

&:hover {
    border:1px solid #e1e1e1;
    transform: scale(1.05)
}
`
const ImgContainer = styled.div`
width:34px;
height:34px;
border-radius:100%;
overflow:hidden;
display:flex;
justify-content:center;
background:#fff;

& > img {
    height:100%;
}

`